import React from 'react';

import SvgIcon from '../../SvgIcon';
import type { IconProps } from '../types';

const PaymentIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    className={className}
    size={size}
    disabled={disabled}
    stroke="none"
    fill="currentColor"
    strokeWidth={0}
  >
    <path
      opacity="0.2"
      d="M30 16.5C30 18.985 25.5225 21 20 21C17.55 21 15.305 20.6037 13.5662 19.945C18.345 19.6062 22 17.75 22 15.5V12.09C26.565 12.5075 30 14.3225 30 16.5ZM22 10.5C22 8.015 17.5225 6 12 6C6.4775 6 2 8.015 2 10.5C2 12.985 6.4775 15 12 15C17.5225 15 22 12.985 22 10.5Z"
    />
    <path d="M23 11.1962V10.5C23 7.365 18.2712 5 12 5C5.72875 5 1 7.365 1 10.5V15.5C1 18.1112 4.28125 20.1863 9 20.8075V21.5C9 24.635 13.7288 27 20 27C26.2712 27 31 24.635 31 21.5V16.5C31 13.9125 27.8225 11.835 23 11.1962ZM29 16.5C29 18.1525 25.1512 20 20 20C19.5338 20 19.0712 19.9838 18.615 19.9538C21.3112 18.9713 23 17.375 23 15.5V13.2175C26.7337 13.7737 29 15.2838 29 16.5ZM9 18.7812V15.8075C9.99472 15.9371 10.9969 16.0014 12 16C13.0031 16.0014 14.0053 15.9371 15 15.8075V18.7812C14.0068 18.928 13.004 19.0011 12 19C10.996 19.0011 9.99324 18.928 9 18.7812ZM21 13.7413V15.5C21 16.5487 19.4487 17.675 17 18.3587V15.4375C18.6138 15.0463 19.98 14.4637 21 13.7413ZM12 7C17.1512 7 21 8.8475 21 10.5C21 12.1525 17.1512 14 12 14C6.84875 14 3 12.1525 3 10.5C3 8.8475 6.84875 7 12 7ZM3 15.5V13.7413C4.02 14.4637 5.38625 15.0463 7 15.4375V18.3587C4.55125 17.675 3 16.5487 3 15.5ZM11 21.5V20.9788C11.3287 20.9913 11.6613 21 12 21C12.485 21 12.9587 20.9837 13.4237 20.9562C13.9403 21.1412 14.4665 21.2981 15 21.4263V24.3587C12.5513 23.675 11 22.5487 11 21.5ZM17 24.7812V21.8C17.9944 21.9337 18.9967 22.0005 20 22C21.0031 22.0014 22.0053 21.9371 23 21.8075V24.7812C21.0106 25.0729 18.9894 25.0729 17 24.7812ZM25 24.3587V21.4375C26.6138 21.0462 27.98 20.4637 29 19.7412V21.5C29 22.5487 27.4487 23.675 25 24.3587Z" />
  </SvgIcon>
);

export default PaymentIcon;
